import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useCmsFaqs } from '@/hooks/useCmsContent';

const FAQS = [
  { q: 'O que é o Marketplace TVDE?', a: 'O Marketplace TVDE é uma plataforma online portuguesa onde anunciantes publicam viaturas para TVDE e motoristas manifestam interesse. Liga proprietários de viaturas, motoristas e investidores do mercado TVDE.' },
  { q: 'Como publico um anúncio de viatura?', a: 'Clique em Anunciar a minha Viatura, valide o seu email através de um código, preencha os dados da viatura e conclua a publicação. O anúncio fica pendente de aprovação antes de ficar visível.' },
  { q: 'Quanto custa anunciar no Marketplace TVDE?', a: 'Publicar que procura viatura (motoristas) é sempre gratuito. Para as viaturas, o preço e a duração são definidos na plataforma e apresentados no momento da publicação — durante o período gratuito não há qualquer cobrança. Quando os pagamentos forem ativados, serão processados de forma segura por um prestador certificado.' },
  { q: 'O Marketplace TVDE está em conformidade com o RGPD?', a: 'Sim. Os dados são tratados de acordo com o RGPD e a nossa Política de Privacidade. Recolhemos apenas os dados necessários à intermediação dos anúncios.' },
  { q: 'Como contacto um anunciante?', a: 'Abra o anúncio e use o botão de contacto. Verifica o seu email e, se quiser partilhar o telemóvel, valida-o por SMS. A mensagem é enviada diretamente ao anunciante.' },
  { q: 'O Marketplace garante as viaturas?', a: 'Não. O Marketplace é apenas intermediário e não é parte nos negócios. Os anúncios são revistos antes da publicação, mas recomendamos verificar sempre documentação (DUA, seguro, inspeção) e ver a viatura presencialmente.' },
  { q: 'Como denuncio um anúncio?', a: 'Em cada anúncio existe um botão "Denunciar anúncio". Escolha o motivo e, se quiser, adicione uma explicação. A equipa analisa todas as denúncias.' },
  { q: 'Como elimino o meu anúncio?', a: 'Use "Gerir o meu anúncio", valide o email por código e pode editar ou apagar o anúncio a qualquer momento.' },
];

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-slate-200" data-testid="faq-item">
      <button
        onClick={() => setOpen((o) => !o)}
        className="flex w-full items-center justify-between gap-3 py-4 text-left"
        data-testid="faq-question"
      >
        <span className="text-sm font-bold text-slate-900">{q}</span>
        <ChevronDown className={`h-4 w-4 shrink-0 text-emerald-600 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && <p className="pb-4 text-sm leading-relaxed text-slate-600" data-testid="faq-answer">{a}</p>}
    </div>
  );
}

export default function FaqSection() {
  const cmsFaqs = useCmsFaqs();
  // Fallback: se o CMS não tiver FAQs publicadas, mantém as perguntas atuais (nunca vazio).
  const list = (Array.isArray(cmsFaqs) && cmsFaqs.length > 0)
    ? cmsFaqs.map((f) => ({ q: f.pergunta, a: f.resposta }))
    : FAQS;
  return (
    <section className="mx-auto w-full max-w-3xl px-4 py-14 md:px-6" data-testid="faq-section">
      <h2 className="mb-2 text-2xl font-extrabold text-slate-900">Perguntas frequentes</h2>
      <p className="mb-6 text-sm text-slate-500">Tudo o que precisa de saber sobre o Marketplace TVDE.</p>
      <div className="rounded-2xl border border-slate-200 bg-white px-5">
        {list.map((f) => <FaqItem key={f.q} {...f} />)}
      </div>
    </section>
  );
}
